module.exports = __webpack_public_path__ + "static/media/home-page-3.6b360ffe.jpg";